import moment from 'moment';
import { CopyToClipboardIcon } from '../../assets/Icon';
import { formatCurrency } from '../../utility/number.utils';
import type { ColumnConfig } from '../ui/Table';
import TransactionLink from '../ui/TransactionLink';

export const transactionTableColumns: ColumnConfig[] = [
  {
    title: 'Transaction No.',
    key: 'transactionId',
    sortable: false,
    width: '300px',
    renderer: (_, row) => {
      return (
        <div>
          <a
            target="_blank"
            href={`${process.env.REACT_APP_TRANSACTION_ID}/transactions?transactionId=${row?.transactionId}&network=${process.env.REACT_APP_NETWORK}`}
            style={{ textDecoration: 'none', color: '#1d77ff' }}
          >
            {`${row?.transactionId.slice(0, 5)}...${row?.transactionId.slice(-3)}`}
          </a>
          <a
            style={{
              marginLeft: '5px',
              border: 'none',
              backgroundColor: 'transparent',
            }}
            onClick={() => navigator.clipboard.writeText(row?.transactionId)}
          >
            <CopyToClipboardIcon />
          </a>
        </div>
      );
    },
  },
  {
    title: '# of Tokens',
    key: 'tokenAmount',
    sortable: false,
    renderer: (value: number | string) => (
      <span>
        {formatCurrency(value ?? 0, {
          currency: '',
          decimals: 0,
        })}
      </span>
    ),
  },
  {
    title: 'Transaction Date & Time',
    key: 'transactionDate',
    sortable: false,
    renderer: (value: Date) =>
      value ? moment(value).format('MMM D YYYY HH:mm:ss') : null,
  },
  {
    title: 'Status',
    key: 'status',
    sortable: false,
    renderer: (value: string) => (
      <span className={`${value === 'BURN' ? 'text-danger' : ''}`}>
        {value}
      </span>
    ),
  },
];

export const transferHistoryTableColumns: ColumnConfig[] = [
  {
    title: 'Employee/Group Name',
    key: 'tokenType',
    sortable: false,
    renderer: (_, row) =>
      row?.receiverBy?.firstName || row?.receiverBy?.lastName
        ? `${row?.receiverBy?.firstName?.trim()} ${row?.receiverBy?.lastName?.trim()}`.trim()
        : row?.receiverBy?.email || '-',
  },
  {
    title: 'Transaction No',
    key: 'transactionNo',
    sortable: false,
    width: '300px',
    renderer: value =>
      value ? <TransactionLink transactionNo={value} /> : '-',
  },
  {
    title: 'Transfered Amount',
    key: 'tokenAmount',
    sortable: false,
    renderer: (value: string | number) =>
      formatCurrency(value, { currency: '', decimals: 0 }),
  },
  {
    title: 'Transaction Date & Time',
    key: 'transactionDate',
    sortable: false,
    renderer: (value: Date) =>
      value ? moment(value).format('MMM D YYYY, HH:mm:ss') : null,
  },
  {
    title: 'Status',
    key: 'status',
    sortable: false,
  },
];
